// extracted by mini-css-extract-plugin
export var row = "_u1-0";